import { render, staticRenderFns } from "./ModerationReviewModal.vue?vue&type=template&id=30c4d38a&scoped=true"
import script from "./ModerationReviewModal.vue?vue&type=script&lang=ts"
export * from "./ModerationReviewModal.vue?vue&type=script&lang=ts"
import style0 from "./ModerationReviewModal.vue?vue&type=style&index=0&id=30c4d38a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4d38a",
  null
  
)

export default component.exports